import { FC, useState } from 'react';

interface IShowMoreText {
  text: string;
  limit?: number;
}

const LIMIT = 20;
export const ShowMoreText: FC<IShowMoreText> = (props) => {
  const { text, limit = LIMIT } = props;

  const [showMore, setShowMore] = useState<boolean>(false);

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  const words = text.split(' ');
  const displayText = words.slice(0, limit).join(' ');
  const hidedText = words.slice(limit, words.length).join(' ');

  return (
    <div>
      {displayText}
      <div className={`overflow-hidden ${showMore ? 'max-h-[500px]' : 'max-h-0'} transition-all duration-700`}>
        <span>
          {hidedText}
        </span>
      </div>
      {words.length > limit && (
        <button className="text-dark-blue underline" onClick={toggleShowMore}>
          {!showMore && 'Read More'}
        </button>
      )}
    </div>
  );
}
